const t = {
  name: "InstantCardPayout",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,7.6V0h2v7.6l3.3-3.3l1.4,1.4L19,11.4l-5.7-5.7l1.4-1.4L18,7.6z"/>
		<path class="st0" d="M5,35h12v-2H5V35z"/>
		<path class="st0" d="M5,14c-2.8,0-5,2.2-5,5v16c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V19c0-2.8-2.2-5-5-5H5z M2,19c0-1.7,1.3-3,3-3
			h30c1.7,0,3,1.3,3,3H2z M2,21h36v3H2V21z M2,35v-9h36v9c0,1.7-1.3,3-3,3H5C3.3,38,2,36.7,2,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as InstantCardPayout
};
